import Modal from "./Modal";
import Button from "./Button";
import ButtonLoadingSpinner from "../loader/ButtonLoadingSpinner";

export const DeleteDialog = ({ yesFunction, noFunction, title, message, isLoading = false, loadingText = "Deleting..." }) => {
    return (
        <Modal
            isOpen={true}
            onClose={isLoading ? () => {} : noFunction}
            size="sm"
            hideHeader
            footer={
                <>
                    <Button variant="secondary" onClick={noFunction} disabled={isLoading}>No, cancel</Button>
                    <Button variant="danger" onClick={yesFunction} disabled={isLoading}>
                        {isLoading ? <ButtonLoadingSpinner loadingText={loadingText} /> : "Yes, I'm sure"}
                    </Button>
                </>
            }
        >
            <div className="text-center py-4">
                <svg className="mx-auto mb-4 text-muted w-12 h-12" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                </svg>
                <h3 className="text-title-sm text-ink mb-2">
                    {title || "Are you sure?"}
                </h3>
                <p className="text-body-md text-body">
                    {message || "Are you sure you want to delete this campaign?"}
                </p>
            </div>
        </Modal>
    );
};

export default DeleteDialog;
